import React from "react";
import ContentGuard from "../components/ContentGuard";
import ComingSoon from "./ComingSoon";

const PayrollPage = () => {
  return (
    <ContentGuard
      hasContent={false}
      fallbackMessage="Payroll management features are coming soon!"
    >
      <div>{/* Payroll content will go here */}</div>
    </ContentGuard>
  );
};

export default PayrollPage;
